import { Check, ArrowRight, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const comparisonData = [{
  metric: "1/4 Truck Load",
  inHouse: "$175 - $225",
  m2k: "14-16 Large Bags",
  description: "Perfect for small cleanups or single room decluttering."
}, {
  metric: "1/2 Truck Load",
  inHouse: "$325 - $395",
  m2k: "Small Apartment",
  description: "Ideal for clearing out a small apartment or a packed garage."
}, {
  metric: "Full Truck Load",
  inHouse: "$595 - $675",
  m2k: "Full Room / 2 Tons",
  description: "Our maximum capacity for whole-home or construction debris."
}];
export default function AgencyVsInHouse() {
  return <section data-section-id="256528" id="load-size-estimates" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-foreground">
            Transparent Pricing. Always.
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg font-default">
            Our Ottawa junk removal rates are based on how much space your items take up in our custom 14-cubic yard trucks.
          </p>
          <p className="text-muted-foreground mx-auto mt-2 max-w-2xl text-base font-default">
            Same‑day service available for most Ottawa locations. Eco‑friendly disposal is included in all estimates.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {comparisonData.map((tier, i) => <div key={i} data-index={i} className="bg-card border-border flex flex-col rounded-lg border p-8 shadow-xl transition-all hover:shadow-2xl">
              <div className="mb-6">
                <h3 className="font-serif text-2xl font-bold text-foreground">
                  {tier.metric}
                </h3>
                <div className="text-secondary mt-2 font-mono text-3xl font-bold">
                  {tier.inHouse}
                </div>
              </div>
              
              <div className="mb-8 flex-grow">
                <p className="text-muted-foreground mb-6 text-sm">
                  {tier.description}
                </p>
                <div className="flex items-start gap-3 text-foreground">
                  <Check className="text-secondary mt-1 size-5 shrink-0" />
                  <span className="font-medium">Fits: {tier.m2k}</span>
                </div>
              </div>

              <div className="mt-auto pt-6 border-t border-border/50">
                <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  <Check className="size-3" />
                  Eco-Friendly Disposal
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 flex flex-col items-center gap-4">
          <Button asChild size="lg" className="group bg-secondary hover:bg-secondary/90 text-secondary-foreground w-full max-w-md rounded-lg shadow-md py-7 text-lg font-bold">
            <Link to="sms:+16135550123">
              <MessageSquare className="mr-2 size-5" />
              Text Us Photos for Instant Estimate
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="group border-border hover:bg-muted text-foreground w-full max-w-md rounded-lg shadow-sm">
            <Link to="/PricingPage">
              Get a Detailed Quote
              <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}